<template>
  <div v-if="loadingStatus" class="body-max-width-background-color">
    <div class="body-max-width">
      <Header title=""></Header>
    </div>
    <div class="flex-mid">
      <div
        class="fs-18 fc-000000 pt-40"
        style="margin-left: -25px; margin-right: -25px; overflow: hidden"
      >
        <div class="pt-10 center" style="width: 100%; overflow: hidden">
          <img
            src="@/assets/image/Well_Line02_.gif"
            alt="Loading"
            class=""
            style="
              width: 120%;
              margin-left: -20px;
              height: 120%;
              object-fit: cover;
              overflow: hidden;
            "
          />
        </div>
        <div class="dialog-water">
          <div class="fs-18 fw-500 center">{{ $t("loading") }}</div>
        </div>
        <!-- <div class="center">{{ $t("loading") }}</div> -->
      </div>
    </div>
  </div>

  <div v-else>
    <div class="body-max-width">
      <Header
        back="/home"
        menu="disable"
        :title="$t('allAppointment')"
      ></Header>
    </div>
    <div class="body-max-width mt-10">
      <div
        v-for="appointment in appointmentData"
        :key="appointment.appointemntId"
        class="appointment-data"
      >
        <div
          class="appointment-card"
          @click="seeHospitalVisit(appointment.appointmentId)"
        >
          <div v-if="currentGuardian" class="name flex-mid">
            <p class="text">
              {{ userData.firstName }}&nbsp;{{ userData.lastName }}&nbsp;{{
                $t("me")
              }}
            </p>
          </div>
          <div class="appointment-detail">
            <div class="appointment-date mx-auto">
              <div class="circle-date">
                <div class="content">
                  <div class="date flex-mid">{{ appointment.date }}</div>
                  <div class="month flex-mid">{{ appointment.month }}</div>
                </div>
              </div>

              <div class="icon flex-mid">
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 7H17"
                    stroke="#6DB557"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 3H2C1.44772 3 1 3.44772 1 4V18C1 18.5523 1.44772 19 2 19H16C16.5523 19 17 18.5523 17 18V4C17 3.44772 16.5523 3 16 3Z"
                    stroke="#6DB557"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.5 13H6.5"
                    stroke="#6DB557"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 10.5V15.5"
                    stroke="#6DB557"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13 1V3"
                    stroke="#6DB557"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 1V3"
                    stroke="#6DB557"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div class="appointment-image">
              <img src="@/assets/image/NewDesign/health-checkup-package.png" />
            </div>
            <div class="appointment-information">
              <p class="appointment-header">{{ $t("healthCheckup") }}</p>

              <div v-if="appointment.packageAmount > 1">
                <p class="appointment-package">
                  {{ "( " + appointment.packageAmount }}
                  {{ $t("manyPackage") + " )" }}
                </p>
              </div>
              <div v-else>
                <p class="appointment-package">
                  {{ "( " + appointment.packageAmount }}
                  {{ $t("package") + " )" }}
                </p>
              </div>
              <hr />
              <p class="hospital-visit">{{ $t("hospitalVisit") }}</p>
              <div class="location-box">
                <div class="hospital">
                  <div class="icon">
                    <svg
                      width="14"
                      height="16"
                      viewBox="0 0 14 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.1225 3.46439C10.5909 3.9287 10.9626 4.47995 11.2161 5.08667C11.4696 5.69338 11.6 6.34367 11.6 7.00039C11.6 7.65711 11.4696 8.30739 11.2161 8.91411C10.9626 9.52082 10.5909 10.0721 10.1225 10.5364L6.55604 14.0704L2.98955 10.5354C2.5212 10.0711 2.14967 9.51976 1.89621 8.91306C1.64273 8.30635 1.51227 7.65608 1.51227 6.99939C1.51227 6.34269 1.64273 5.69243 1.89621 5.08572C2.14967 4.47901 2.5212 3.92774 2.98955 3.46339C3.45792 2.99903 4.01394 2.63069 4.62587 2.37938C5.23781 2.12807 5.89368 1.99873 6.55604 1.99873C7.2184 1.99873 7.87426 2.12807 8.4862 2.37938C9.09816 2.63069 9.65411 3.00003 10.1225 3.46439ZM11.1917 11.5964C12.1086 10.6874 12.733 9.52918 12.9861 8.26829C13.2391 7.0074 13.1092 5.70043 12.6131 4.51268C12.1169 3.32493 11.2766 2.30974 10.1985 1.59548C9.12025 0.881232 7.85272 0.5 6.55604 0.5C5.25935 0.5 3.99179 0.881232 2.91364 1.59548C1.8355 2.30974 0.995196 3.32493 0.498995 4.51268C0.00280384 5.70043 -0.126996 7.0074 0.126017 8.26829C0.379029 9.52918 1.00349 10.6874 1.92041 11.5964L5.48589 15.1324C5.62639 15.2718 5.79321 15.3824 5.97684 15.4578C6.16046 15.5333 6.35728 15.5721 6.55604 15.5721C6.7548 15.5721 6.95162 15.5333 7.13524 15.4578C7.31885 15.3824 7.48568 15.2718 7.62618 15.1324L11.1917 11.5964ZM6.55604 9.00039C7.09105 9.00039 7.60413 8.78967 7.98245 8.4146C8.36075 8.03953 8.57328 7.53082 8.57328 7.00039C8.57328 6.46995 8.36075 5.96125 7.98245 5.58617C7.60413 5.2111 7.09105 5.00039 6.55604 5.00039C6.02103 5.00039 5.50794 5.2111 5.12963 5.58617C4.75133 5.96125 4.53879 6.46995 4.53879 7.00039C4.53879 7.53082 4.75133 8.03953 5.12963 8.4146C5.50794 8.78967 6.02103 9.00039 6.55604 9.00039Z"
                        fill="#545454"
                      />
                    </svg>
                  </div>
                  <p class="hospital-name">
                    {{ $t(appointment.hospitalName) }}
                  </p>
                </div>
                <div class="seperate-line">
                  <p>|</p>
                </div>
                <div class="time">
                  <p>{{ appointment.time }} {{ $t("timeOclock") }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import { Mousewheel } from "swiper";
import "swiper/swiper.min.css";
//   import "swiper/modules/autoplay/autoplay.scss";
import axios from "axios";
// import * as config from "@/assets/js/config.js";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
SwiperCore.use([EffectCoverflow, Pagination]);
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");

export default defineComponent({
  name: "AllAppointment",
  components: {
    Header,
  },
  setup() {
    return {};
  },

  data() {
    return {
      loadingStatus: true,
      accessToken: "",
      lang: "",
      channel: "",
      username: "",
      memberId: "",
      appointmentData: [],
      useerData: "",
      currentGuardian: false,
    };
  },

  mounted() {
    this.channel = this.$cookies.get("channel");
    this.lang = this.$cookies.get("lang");
    this.username = this.$cookies.get("username");
    this.memberId = this.$cookies.get("memberId");
    this.accessToken = this.$cookies.get("access_token");
    this.getAppointment();
    this.getData();
  },
  watch: {},
  computed: {},
  methods: {
    getAppointment() {
      axios
        .get(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/appointment/get",

          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          const data = res.data;
          const appDetail = [];
          if (data.length != 0) {
            for (let i = 0; i < data.length; i++) {
              this.haveAppointment = true;
              const dateTime = new Date(data[i].primaryDateTime);
              const date = dateTime.getDate();
              let month = "";
              if (this.lang == "th") {
                month = dateTime.toLocaleString("th-TH", {
                  month: "short",
                });
              } else {
                month = dateTime.toLocaleString("en-EN", {
                  month: "short",
                });
              }

              const AppDate = dateTime.toLocaleDateString("en-GB", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });

              const time = dateTime.toLocaleString("default", {
                hour: "numeric",
                minute: "numeric",
                hour12: false,
              });

              appDetail.push({
                date: date,
                month: month,
                time: time,
                hospitalName: data[i].site,
                appointmentCode: data[i].appointmentCode,
                appointmentId: data[i].appointmentId,
                packageAmount: data[i].packageNumber,
              });
            }
          }
          appDetail.sort((a, b) => {
            return a.date - b.date;
          });
          this.appointmentData = appDetail;
        })
        .catch((error) => {
          this.error = error;
          window.$("#errorModal").modal("show");
        });
    },
    getData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/get",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          const data = res.data;
          this.userData = data.customer;
          if (this.userData.currentGuardian != null) {
            this.currentGuardian = true;
          }
          this.loadingStatus = false;
        })
        .catch((error) => {
          if (error.response.status == 403) {
            this.getNewToken();
          } else {
            this.error = error;
            window.$("#errorModal").modal("show");
          }
        });
    },
    seeHospitalVisit(value) {
      this.$router.push({
        path: "/appointment-detail",
        query: { appointmentId: value },
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.appointment-data {
  .appointment-card {
    width: 100%;
    // height: 10rem;
    border-radius: 15px;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);

    .name {
      background: #abeb97;
      height: 3rem;
      border-radius: 15px 15px 0 0;
      display: flex;
      width: 100%;
      align-items: center;

      .text {
        font-size: 14px;
        font-weight: 400;
        line-height: 3rem;
        letter-spacing: 0em;
        color: #000000;
        margin: auto;
      }
    }

    .appointment-detail {
      display: grid;
      width: 100%;
      grid-template-columns: 25% 20% auto;
      gap: 1rem;
      padding: 1rem 1rem;

      .appointment-date {
        display: block;

        .circle-date {
          background: #57b43c;
          width: 7rem;
          height: 7rem;
          border-radius: 7rem;
          padding: 1rem;

          .content {
            margin: auto;
            margin-top: 1rem;

            .date {
              margin: auto;
              color: #ffffff;
              font-size: 24px;
              font-weight: 500;
              line-height: 80%;
            }

            .month {
              margin: auto;
              color: #ffffff;
              font-size: 14px;
              font-weight: 500;
            }
          }
        }

        .icon {
          margin-top: 2rem;
        }
      }

      .appointment-image {
        display: block;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          overflow: hidden;
          border-radius: 12px;
        }
      }

      .appointment-information {
        .appointment-header {
          color: #000000;
          font-size: 16px;
          font-weight: 500;
          line-height: 16px;
          letter-spacing: 0.20000000298023224px;
          text-align: left;
        }

        .appointment-package {
          color: #000000;
          font-size: 16px;
          font-weight: 500;
          line-height: 16px;
          margin-top: 0rem;
          letter-spacing: 0.20000000298023224px;
          text-align: left;
        }

        hr {
          border: 2px #abeb97 solid;
          width: 100%;
        }

        .hospital-visit {
          font-size: 14px;
          font-weight: 400;
          line-height: 21px;
          letter-spacing: 0em;
          text-align: left;
        }

        .location-box {
          // display: inline-flex;
          color: #545454;
          font-size: 13px;
          // font-weight: 400;
          // line-height: 20px;
          // text-align: left;
          display: grid;
          grid-template-columns: 55% 10% 35%;

          .hospital {
            display: flex;

            .icon {
            }

            .hospital-name {
              margin-left: 0.5rem;
            }
          }

          .seperate-line {
            margin: 0 0.5rem 0 0.5rem;
          }

          .time {
          }
        }
      }
    }
  }
}
</style>
